import { queryOptions } from '@tanstack/react-query';
import { LOCALES, type Locale } from '@shop/types';

import { api } from './api';
import type { Attribute, Brand, Category, Manufacturer, Translations } from './types';

/** Справочники каталога: меняются редко, используются во многих формах. */
export const categoriesQuery = queryOptions({
  queryKey: ['catalog', 'categories'],
  queryFn: () => api<{ items: Category[] }>('/catalog/categories').then((r) => r.items),
});

export const brandsQuery = queryOptions({
  queryKey: ['catalog', 'brands'],
  queryFn: () => api<{ items: Brand[] }>('/catalog/brands').then((r) => r.items),
});

export const manufacturersQuery = queryOptions({
  queryKey: ['catalog', 'manufacturers'],
  queryFn: () => api<{ items: Manufacturer[] }>('/catalog/manufacturers').then((r) => r.items),
});

export const attributesQuery = queryOptions({
  queryKey: ['catalog', 'attributes'],
  queryFn: () => api<{ items: Attribute[] }>('/catalog/attributes').then((r) => r.items),
});

/** Контент каталога — на языках витрины. Порядок: языки рынков, затем ru/en. */
export const CONTENT_LOCALES: readonly Locale[] = LOCALES;

/** Подпись из переводов: язык интерфейса → любой имеющийся. */
export function pickTranslation<T>(
  translations: Translations<T>,
  uiLanguage: string,
): T | undefined {
  const byUi = translations[uiLanguage as Locale];
  if (byUi) return byUi;
  for (const locale of CONTENT_LOCALES) {
    const value = translations[locale];
    if (value) return value;
  }
  return undefined;
}

/** Путь категории «Кухня / Мойки» для выпадающих списков. */
export function categoryLabel(category: Category, all: Category[], uiLanguage: string): string {
  const byId = new Map(all.map((c) => [c.id, c]));
  const names: string[] = [];
  let current: Category | undefined = category;
  while (current) {
    names.unshift(pickTranslation(current.translations, uiLanguage)?.name ?? current.id);
    current = current.parentId ? byId.get(current.parentId) : undefined;
  }
  return names.join(' / ');
}
